var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h48v48H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1982BA",
  d: "M12 12h24v24H12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.632 32V21.204h-3.43V32h3.43Zm-1.714-12.27c1.196 0 1.94-.829 1.94-1.865-.022-1.06-.744-1.865-1.917-1.865-1.174 0-1.941.806-1.941 1.865 0 1.036.744 1.865 1.895 1.865h.023ZM21.53 32h3.43v-6.028c0-.323.022-.646.112-.876.248-.645.812-1.312 1.76-1.312 1.24 0 1.737.99 1.737 2.441V32H32v-6.19c0-3.316-1.692-4.859-3.948-4.859-1.85 0-2.663 1.082-3.114 1.819h.022v-1.566h-3.43c.046 1.013 0 10.796 0 10.796Z",
  fill: "#FFF"
}))));
export default SvgLinkedin;